<!-- Full viewport layout (no scroll), or container-sized layout in compact mode -->
<div class="flex flex-col" [class.bg-station-cream]="!compact()" [class.h-full]="!compact()">
  <!-- Header - Optional -->
  @if (showHeader()) {
    <header
      class="h-16 bg-white border-b-4 border-signal-orange px-8 flex items-center justify-center"
    >
      <h1 class="text-2xl md:text-3xl font-bold text-flap-black text-center">
        {{ headerText() || 'FlippyBoards.com' }}
      </h1>
    </header>
  }

  <!-- Main Board Display - Fill remaining space -->
  <main class="flex items-center justify-center overflow-hidden" [class.flex-1]="!compact()">
    <div
      class="bg-flap-black w-full flex items-center justify-center"
      [class.h-full]="!compact()"
      [class.p-4]="!compact()"
      [class.@container]="compact()"
    >
      <!-- The message in text form. A grid of flaps reads as a stream of
           disconnected, constantly mutating single letters, so the grid is
           hidden from assistive tech and this stands in for it. In compact
           mode the board is an embedded preview and the host page supplies
           its own heading, so announcing every rotation would just be noise. -->
      @if (!compact()) {
        <p class="sr-only" aria-live="polite" aria-atomic="true">{{ currentMessage() }}</p>
      }

      <!-- Split-flap grid -->
      <div
        aria-hidden="true"
        class="grid gap-0.5 md:gap-1 w-full max-w-full max-h-full"
        [class.h-full]="!compact()"
        [style.grid-template-columns]="'repeat(' + cols() + ', minmax(0, 1fr))'"
        [style.grid-template-rows]="
          compact() ? 'repeat(' + rows() + ', auto)' : 'repeat(' + rows() + ', minmax(0, 1fr))'
        "
      >
        <!-- Individual flap character. Keying on the grid shape remounts every
             flap when the board is resized, so they all restart from the blank
             and the settle estimate matches what is actually on screen. -->
        @for (charData of characters(); track rows() + 'x' + cols() + ':' + $index) {
          <div
            class="aspect-[3/4]"
            [style.font-size]="
              compact() ? 'calc(80cqw / ' + cols() + ')' : 'calc(80vw / ' + cols() + ')'
            "
          >
            <app-split-flap-character
              [style.--flap-background]="charData.background"
              [style.--flap-color]="charData.color"
              [targetChar]="charData.char"
              [staggerDelay]="charData.staggerDelay"
              [muted]="muted()"
              [alphabet]="alphabet()"
              [paused]="paused()"
            />
          </div>
        }
      </div>
    </div>
  </main>

  <!-- Footer - Optional -->
  @if (showFooter()) {
    <footer
      class="h-16 bg-white border-t-4 border-signal-orange px-8 flex items-center justify-between"
    >
      <div class="flex-1"></div>
      <p class="text-center text-sm text-rail-gray">
        @if (footerText()) {
          {{ footerText() }}
        } @else {
          Powered by
          <a
            href="https://flippyboards.com"
            class="text-signal-orange hover:underline font-semibold"
            >FlippyBoards.com</a
          >
        }
      </p>
      <div class="flex-1 flex justify-end">
        <label class="flex items-center gap-2 text-sm text-rail-gray cursor-pointer select-none">
          <input
            type="checkbox"
            [checked]="audioService.isMuted()"
            (change)="audioService.toggleMute()"
            class="accent-signal-orange w-4 h-4 cursor-pointer"
          />
          Mute Flippyboard
        </label>
      </div>
    </footer>
  }
</div>
